import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6zj4dcu23e: FaireBrandEntity = {
  token: "b_6zj4dcu23e",
  type: "brand",
  name: "Threads And Needles, INC.",
  avatarUrl:
    "https://cdn.faire.com/fastly/216ffce36f3ba263e45e99727dcd3820d8c114dd3461592a2aedb503a649fedc.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/7ea2b638ff2ffa50f44f7c670ac691f855fa53766819e4cc58d6aa3a613155e7.png",
  logoUrl:
    "https://cdn.faire.com/fastly/216ffce36f3ba263e45e99727dcd3820d8c114dd3461592a2aedb503a649fedc.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7ea2b638ff2ffa50f44f7c670ac691f855fa53766819e4cc58d6aa3a613155e7.png",
  location: "Chicago, IL, USA",
  minimumOrderDollars: 139,
  rating: 4.7,
  reviewCount: 98,
  isInsider: true,
  description:
    "Make significant and everyday moments more intimate and special with us. We are Threads and Needles, a small business from Chicago that was established in the midst of Covid in 2020. With prayers and perseverance, to this day we can proudly say we have made over 40,000 sales in our online retail store and currently have a 4.9 average rating from over 8K+ reviews. We are fairly new to Faire and would love for you to join us in this exciting journey! Thank you so much for supporting our small business. Please let us know if you have any questions. We are looking forward to build a long-term relationship with all of you. ♡",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:59.136Z",
    importedBy: "entity-db-cli",
  },
};
